module.exports = __webpack_public_path__ + "img/9788997798315.d2ad1108.jpg";